<template>
  <card-minimal title="Scorebar" subTitle="The scorebar is only visible on output stream and only when the broadcast is live" v-if="broadcast">
    <div class="d-f fd-c fd-md-r f-g p-x-4 p-t-4">
      <div class="f-1 d-f">
        <div class="f-1 m-r-1">
          <label>Home team</label>
          <form-input :value="sport.home_team_name" @input="sport.home_team_name = $event" />
        </div>
        <div class="f-1 m-l-1">
          <label>Score</label>
          <form-input :value="sport.home_team_score" type="number" :stepper="true" :step="1" @input="sport.home_team_score = parseInt($event, 10)" />
        </div>
      </div>
      <div class="f-1 d-f">
        <div class="f-1 m-r-1">
          <label>Away team</label>
          <form-input :value="sport.away_team_name" @input="sport.away_team_name = $event" />
        </div>
        <div class="f-1 m-l-1">
          <label>Score</label>
          <form-input :value="sport.away_team_score" type="number" :stepper="true" :step="1" @input="sport.away_team_score = parseInt($event, 10)" />
        </div>
      </div>
    </div>
    <div class="p-x-4 p-b-4">
      <Button :class="`large`" :loading="loading" :disabled="loading" @click="update">Update scores</Button>
    </div>
  </card-minimal>
</template>

<script>

export default {
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
  },
  methods: {
    /**
     * Update the scorebar with given values
     * @returns {Void}
     */
    async update() {
      const {
        broadcast: {
          id,
        },
        sport: {
          home_team_name, home_team_score, away_team_name, away_team_score, playing_period,
        },
      } = this;

      this.loading = true;

      const update = await this.$store.dispatch('Broadcast/update', {
        id,
        data: {
          metadata: {
            sport: {
              home_team_name,
              home_team_score: `${home_team_score}`,
              away_team_name,
              away_team_score: `${away_team_score}`,
              playing_period: `${playing_period}`,
            },
          },
        },
      });

      if (!update) {
        swal({ title: 'An error occured', text: this.$t('scorebar.could_not_update'), icon: 'error' });
      }

      this.loading = false;
    },
  },
  data() {
    return {
      loading: false,
      sport: {
        playing_period: 0,
        away_team_name: '',
        away_team_score: 0,
        home_team_name: '',
        home_team_score: 0,
      },
    };
  },
  mounted() {
    if (this.broadcast) {
      const { sport = null } = this.broadcast.metadata;
      if (sport) {
        this.sport = sport;
      }
    }
  },
};
</script>
